import classNames from "classnames";
import dayjs from "dayjs";
import { useTranslations } from "next-intl";
import { useCurrentTime } from "~/hooks/useCurrentTime";
import {
    IS_APITEL_TEMPLATE,
    IS_PMDF_TEMPLATE,
    IS_PR_TEMPLATE,
    IS_PRF_TEMPLATE,
    IS_TRN_TEMPLATE,
} from "~/utils/constants";

interface ResendTokenTimerProps {
  lastSentAt: Date;
  timeInMinutes?: number;
}

export const ResendTokenTimer: React.FC<ResendTokenTimerProps> = ({
  lastSentAt,
  timeInMinutes = 10,
}) => {
  const { now } = useCurrentTime();
  const t = useTranslations();

  const timeInSeconds = 60 * timeInMinutes; // 10 minutos

  const diffInSeconds = Math.abs(dayjs(now).diff(lastSentAt, "seconds"));

  const minutes = Math.floor((timeInSeconds - diffInSeconds) / 60);
  const seconds = (timeInSeconds - diffInSeconds) % 60;

  if (minutes < 0) {
    return null;
  }

  const formattedTime = `${String(minutes).padStart(2, "0")}:${String(
    seconds,
  ).padStart(2, "0")}`;

  return (
    <span
      className={
        classNames(
          "tracking-tighter",
          {
            "text-app-gray-500 text-[0.75rem]": IS_PRF_TEMPLATE,
            "text-app-gray-900/50 text-[0.55rem] -mt-2": IS_TRN_TEMPLATE,
            "text-app-gray-200/60 text-[0.55rem] -mt-2": IS_PR_TEMPLATE || IS_PMDF_TEMPLATE || IS_APITEL_TEMPLATE,
            "text-app-gray-200 text-[0.75rem]": !IS_PRF_TEMPLATE,
          },
        )
      }
    >
      {t("blocked-status")} {formattedTime}
    </span>
  );
};
